import { render, staticRenderFns } from "./TextareaElement.vue?vue&type=template&id=54227284&scoped=true&"
import script from "./TextareaElement.vue?vue&type=script&lang=js&"
export * from "./TextareaElement.vue?vue&type=script&lang=js&"
import style0 from "./TextareaElement.vue?vue&type=style&index=0&id=54227284&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54227284",
  null
  
)

export default component.exports